import { createStore } from 'satcheljs';
var defaultStore = {
    mruFolders: [],
    isInitialized: false,
};
export var getStore = createStore('mruFolderCache', defaultStore);
var store = getStore();
export default store;
//# sourceMappingURL=store.js.map